import { type SelectInputProps, SelectInput, useGetList } from "react-admin";

import { MODULE_NAMES } from "@/constants/modules";

export const DeviceTypeInput = (
  props: Omit<SelectInputProps, "choices" | "isLoading" | "isPending">,
) => {
  const { isPending, isLoading, data } = useGetList(MODULE_NAMES.DEVICE_TYPES);

  return (
    <SelectInput
      {...props}
      isPending={isPending}
      isLoading={isLoading}
      optionValue={props.optionValue ?? "id"}
      choices={data ?? []}
    />
  );
};
